import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  addLead,
  getLeads,
  getLead,
  editLead,
  deleteLead,
  getAllLeads,
} from "../../store/actions/lead_action";
import { SEARCH_TERMS } from "../enums/leads_enum";
// Get All Data
export const useAllLeads = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.lead);
  const [pageNumber, setPageNumber] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);
  const [q, setQ] = useState(null);
  const [term, setTerm] = useState(null);
  const [termField, setTermField] = useState(SEARCH_TERMS[0]);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  useEffect(() => {
    async function allQuery() {
      if (deleteEntry) {
        await dispatch(deleteLead(deleteEntry));
      }
      if (term && term.length > 0) {
        setQ(term);
        dispatch(
          getLeads({
            termField: termField ? termField : termField,
            term: q ? q : "",
            pageNumber,
            start_from: dateFrom,
            start_to: dateTo,
          })
        );
      } else {
        dispatch(
          getLeads({
            termField: termField ? termField : termField,
            term: q ? q : "",
            pageNumber,
            start_from: dateFrom,
            start_to: dateTo,
          })
        );
      }
    }
    allQuery();
  }, [deleteEntry, term, pageNumber, dateFrom, dateTo]);
  useEffect(() => {
    setPageNumber(1);
  }, [term, dateTo, dateFrom]);

  const deleteBtnClicked = async (id) => {
    setDeleteEntry(id);
  };
  const resetFilter = () => {
    setPageNumber(1);
    setQ(null);
    setTerm("");
    setDateFrom("");
    setDateTo("");
    dispatch(getLeads({}));
  };

  return [
    data,
    pageNumber,
    setPageNumber,
    q,
    term,
    setTerm,
    termField,
    setTermField,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    deleteBtnClicked,
    resetFilter,
  ];
};

// Get Single Data
export const useSingleLead = (id) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.lead);
  useEffect(() => {
    dispatch(getLead(id));
  }, [id]);
  return [data];
};
// Add Data
export const useCreateLead = () => {
  const dispatch = useDispatch();
  const addData = async (data) => {
    await dispatch(addLead(data));
  };
  return [addData];
};
export const useUpdateLead = () => {
  const dispatch = useDispatch();
  const updateData = async (id, data) => {
    await dispatch(editLead(id, data));
  };
  return [updateData];
};

export const useSelectAllLead = () => {
    const dispatch = useDispatch();
    const data = useSelector((state) => state.lead);
    useEffect(() => {
      dispatch(getAllLeads());
    }, []);
    return [data];
  };          